<template>
  <div class="product-card">
    <div class="product_box">
      <buy-one-get-one
        v-if="item.BuyAGetB_promotion"
        v-bind:fromQty="item.BuyAGetB_FromQty"
        v-bind:relatedQty="item.BuyAGetB_RelatedQty"
      ></buy-one-get-one>
      <div class="ProImg">
        <img v-if="favoritesPage" src="../../assets/img/times.svg" class="pc-fav" @click="deFavoriteProduct(item)" style="cursor: pointer"/>
        <a style="width:100%; height:100%;" @click="goToProductDetail(item)">
          <!-- <v-lazy-image 
            :src="this.img"
            alt=""
            :intersection-options="{ rootMargin: '1000px' }"
          /> -->
          <img
            v-lazy="this.img || productFallback"
            :key="this.img || productFallback"
            :src="this.img || productFallback"
            :alt="this.name || 'Product image'"
            @error="useFallbackImage">
        </a>
        <!-- <button v-if="isOutOfStock(item)" class="no_stock">+</button>
        <button
          v-else
          class="mobile_add"
          @click="throttleAddToCart(item, $event)"
        >
          +
        </button> -->
      </div>
      <div class="Pro-Details">
        <div class="price-bot">
          <p class="product-ref">{{ item.RefNum || item.ProductCode || item.Product_id }}</p>
          <p class="ProTitle"><a :href="this.link">{{this.name}}</a></p>
          <p class="product-package">{{ item.PackageSize }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import { flyToElement } from "../../store/modules/cart.js";
import {
  isUserAuthenticated,
  setLocalCart,
  getLocalCart
} from "../../store/modules/cart";
import star0 from '../../assets/img/star0.jpg'
import star1 from '../../assets/img/star1.jpg'
import star2 from '../../assets/img/star2.jpg'
import productFallback from '../../assets/img/afm-logo.png'
import busUtil from "../../assets/js/util";
import buyOneGetOne from "../../components/buy-one-get-one/buy-one-get-one";
import {toProductDetail} from "../../mixin";

export default {
  name: 'productCard',
  mixins: [toProductDetail],
  components: {
    'buy-one-get-one': buyOneGetOne
  },
  props: [
    'img',
    'link',
    'name',
    'brand',
    'isPromotion',
    'price',
    'item',
    'quantity',
    'favoritesPage',
    'rating',
  ],
  data() {
    return {
      productFallback,
      list: [],
      found: false,
      num: 0,
      localCount: 0,
    }
  },
  methods: {
    useFallbackImage(event) {
      const image = event.currentTarget;
      if (image.dataset.fallbackApplied) return;
      image.dataset.fallbackApplied = 'true';
      image.src = this.productFallback;
    },
    ...mapActions('products',['fetchCategories', 'fetchProductsWithGroupId', 'removeProductFromFavorites']),
    ...mapMutations('cart', ['updateProductCount']),
    ...mapActions('cart',['addProductToCart']),
    ...mapMutations('navbar', ['toggleZipcodeModalVisibility', 'toggleWarehouseSelectionModalVisibility']),
    isOutOfStock(item) {
      if(item.IsOverSaleable) {
        return false
      }
      return item.InventoryQuantity > 0 ? false : true
    },
    addToCart: function(item) {
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/addCart', item);
        // this.found = true;
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item);
      }
      if (isUserAuthenticated()) {
        this.$store.dispatch('cart/getCart');
      }
    },
    getItemQuantity: function() {
      if (isUserAuthenticated()) {
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.num = this.cartProductsList.Sales_Order_Lines[i].Quantity;
            this.found = true;
          }
        }
      } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.num = this.cartProductsList[i].quantity;
            this.found = true;
          }
        }
      }
    },
    incrementAddToCart: function(item, add, e) {
      if (add) {
        let quantity = this.num + 1;
        if (isUserAuthenticated()) {
          flyToElement(event.target, $('.cart-link'));
          this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
          .then(() => {
            this.getItemQuantity();
          })
        } else {
          this.$store.dispatch('cart/addProductToLocalCart', item);
        }
      } else if (!add) {
        let quantity = this.num - 1;
        if (quantity < 1) {
          this.deleteItem(item)
        } else {
          if (isUserAuthenticated()) {
            this.$store.dispatch('cart/updateItemQuantity', [item.Product_id, quantity])
            .then(() => {
              this.$store.dispatch('cart/getCart');
            });
          } else {
            item.quantity = quantity;
            this.$store.dispatch('cart/updateLocalCart', item)
            .then(() => {
              this.$store.dispatch('cart/fetchCartProducts')
            });
          }
        }
      }
    },
    throttleAddToCart:  _.debounce(function(item, e) {
      e.preventDefault();
      busUtil.$emit('addToCartDrop', e, item)
      this.addThisToCart(item)
    }, 150, {'leading': true, 'trailing': true}),
    addThisToCart: function(item) {
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Pickup') {
        this.toggleWarehouseSelectionModalVisibility(true);
        return;
      }
      if (!localStorage.getItem('warehouseLocationWeb') && localStorage.getItem('shippingMethodGlobal') === 'Delivery') {
        this.toggleZipcodeModalVisibility(true);
        return;
      }
      if (!this.addToCartLoading) {
        if (isUserAuthenticated()) {
          this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        } else {
          this.$store.dispatch('cart/incrementLocalCart', [item])
        }
      }
    },
    handleAddToCartSuccess(payload) {
      this.$store.dispatch('cart/addCart', payload.item)
      .then(() => {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        }
      });
    },
    handleAddToCartFail(product) {
      if (localStorage.Lang === 'ch') {
        alert( this.$t('stock_msg_1') + `${product.Name}` +  this.$t('stock_msg_2'));
      } else {
        alert(`Sorry, there are only ${product.InventoryQuantity} available of ${product.Name}`);
      }
    },
    checkInsideCart() {
      if (isUserAuthenticated()) {
        if (!this.cartProductsList.Sales_Order_Lines.length) {
          this.found = false;
          this.num = 0;
          return;
        }
        for (var i = 0; i < this.cartProductsList.Sales_Order_Lines.length; i++) {
          if (this.item.Product_id === this.cartProductsList.Sales_Order_Lines[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            return;
          }
        }
      } else {
        //For whatever reason this portion is necessary for removing the found variable when
        //itemCount is below 1.
        if (!this.cartProductsList.length) {
          this.found = false;
          this.num = 0;
          return;
        } else {
        for (var i = 0; i < this.cartProductsList.length; i++) {
          if (this.item.Product_id === this.cartProductsList[i].Product_id) {
            this.found = true;
            return;
          } else {
            this.found = false;
            this.num = 0;
            }
          }
        }
      }
    },
    deleteItem(item) {
      if (!this.itemDeletedLoading) {
        let productId = item.Product_id;
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/deleteCartItem', item.Product_id)
          .then(() => {
            this.$store.dispatch('cart/getCart');
          });
        } else {
          const cartItems = _.filter(this.$store.state.cart.cartProductsList, item => item.Product_id !== productId);
          setLocalCart(cartItems);
          let itemCount = 0;
          cartItems.forEach((item) => {
            itemCount += item.quantity;
          });
          this.$store.dispatch('cart/updateItemQuantity', [productId, itemCount])
          this.$store.dispatch('cart/fetchCartProducts')
        }
      }
    },
    onClickBrand() {
      if (this.brand) {
        if (this.$router.currentRoute.path !== '/collections') {
          this.$router.push(`/collections`);
          setTimeout(() => {
            this.$root.selectNewSearch(this.brand, 'Brand');
          }, 600);
        } else {
          this.$root.selectNewSearch(this.brand, 'Brand');
        }
      }
    },
    deFavoriteProduct(item) {
      this.removeProductFromFavorites(item.Product_id)
    },
    getStarIndex(rating) {
      let temp = [];
      if (rating || rating === 0) {
        for (let i=1; i<6; i++) {
          if (rating >= i) {
          temp.push(star2);
          } else if (rating > (i-1) && rating < i) {
          temp.push(star1);
          } else if (rating <= (i-1)) {
          temp.push(star0);
          }
        }
      } else {
        temp = [star0, star0, star0, star0, star0];
      }
      return temp;
    },
  },
  computed: mapState({
    cartProductsList: state => state.cart.cartProductsList,
    itemCount: state => state.cart.itemCount,
    itemDeletedLoading: state => state.cart.itemDeletedLoading,
    windowHeight: state => state.navbar.windowHeight,
    windowWidth: state => state.navbar.windowWidth,
    addToCartLoading: state => state.cart.addToCartLoading
  }),
}
</script>

<style lang="less">
@import "../../assets/css/public.less";
@import "../../assets/css/productCard.less";
@import "../../assets/query/mobileProductCardSmall.less";
.v-lazy-image {
  filter: blur(5px);
  transition: filter 1.6s;
  will-change: filter;
}
.v-lazy-image-loaded {
  filter: blur(0);
}
</style>



// WEBPACK FOOTER //
// src/view/mobile/mobileProductCardSmall.vue